import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IParticipantGradesQuery } from 'app/library/final-grade/interfaces/participant-grades.query';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';

export interface IParticipantGradesWithTotalCount {
    data: IParticipantGradesQuery[];
    pagination: {
        number_of_pages: number;
        number_of_results: number;
    };
}

@Injectable()
export class ModuleFinalGradesService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    findGrades(moduleId = '', search = '', sortBy = '', sortOrder = '', pageSize = 10, pageIndex = 1): Observable<IParticipantGradesWithTotalCount> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString());

        if (sortBy && sortOrder) {
            switch (sortBy) {
                case 'userFullName':
                    sortBy = 'name';
                    break;
                case 'averageScore':
                    sortBy = 'avg';
                    break;
                case 'gradeNumericValue':
                    sortBy = 'grade';
                    break;
            }

            params = params.set('sortBy', sortBy);
            params = params.set('sortOrder', sortOrder);
        }

        if (search) {
            params = params.set('search', search);
        }

        return this.http.get<IParticipantGradesWithTotalCount>(`${this.environment.apiUrl}/modules/${moduleId}/grades/manager`, { params });
    }

    findModuleFinalGradesForParticipant(moduleId: string, participantId: string): Observable<IParticipantGradesWithTotalCount> {
        let params = new HttpParams().set('filter[participant]', participantId);

        return this.http.get<IParticipantGradesWithTotalCount>(`${this.environment.apiUrl}/modules/${moduleId}/grades/manager`, { params });
    }
}
